export default __webpack_public_path__ + "static/media/FKGroteskNeue-Bold.3e7eae07.woff";